import { render, staticRenderFns } from "./FoodSearchAuto.vue?vue&type=template&id=65d7a910&scoped=true&"
import script from "./FoodSearchAuto.vue?vue&type=script&lang=js&"
export * from "./FoodSearchAuto.vue?vue&type=script&lang=js&"
import style0 from "./FoodSearchAuto.vue?vue&type=style&index=0&id=65d7a910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7a910",
  null
  
)

export default component.exports